import React, {useEffect, useState} from 'react'
import {Button, Modal, Row, Select} from "antd";
import {getRepresentativeByEmployee} from "../../services/serviceEmployeeCustomer";
import {createRepresentative, deleteRepresentative} from "../../services/serviceEmployeeCustomer";

const EmployeeCustomerMatch = ({customers, show, modalCloser, employeeId}) => {
    const [representativeFor, setRepresentativeFor] = useState([]);
    const [startRead, setStartRead] = useState(false);
    const [selectedCustomers, setSelectedCustomers] = useState([]);

    useEffect(() => {
        getRepresentativeByEmployee(employeeId)
            .then(({data}) => {
                if(data) {
                    setSelectedCustomers(getSelectedCustomers(data));
                    setRepresentativeFor(data);
                    setStartRead(!startRead);
                }
            })
    }, [])
    const getSelectedCustomers = (data) => {
        const filtered = data.filter(el => el.customer && el.customer.id);
        return filtered.map(el => el.customer.id);
    };

    const findMatchId = (customerId) => {
        const defined = representativeFor.find(i => i.customer && i.customer.id === customerId);
        if(defined) {
            return defined.id;
        }
    };

    const handleDeSelect = async (val) => {
        const match = findMatchId(val);
        if(match) {
            await deleteRepresentative(match);
        } else {
            return;
        }
    };

    const handleCheck = async (val) => {
        await createRepresentative({
            customer: {
                id: val
            },
            employee: {
                id: employeeId
            }
        });
    };

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'));
    };

    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                title={'Müşteri Temsilcisi Seç'}
                footer={[
                    <Button
                        key={'CancelButton'}
                        type={'primary'}
                        onClick={modalCloser}
                    >
                        Kapat
                    </Button>
                ]}
            >
                    {
                        startRead ?
                        <Row>
                              <Select
                                options={customers} 
                                mode={'multiple'}
                                style={{width: '100%'}} 
                                showSearch 
                                filterOption={selectSearch} 
                                allowClear 
                                placeholder={'Müşteri Seçiniz'}
                                onSelect={handleCheck}
                                onDeselect={handleDeSelect}
                                defaultValue={selectedCustomers}
                            />
                        </Row>    
                           : null
                    }
            </Modal>
        </React.Fragment>
    )
}
export default EmployeeCustomerMatch